import Dashboard from './dashboard/dashboard';
import Login from './login/login';
import MainScreen from './main-screen/main-screen';
import PersonalData from './personal-data/personal-data';
import LoadingScreen from './loading-screen/loading-screen';
import Profile from './profile/profile';
import Settings from './settings/settings';
import Contact from './contact/contact';
import Notifications from './notifications/notifications';
import LogoutSettings from './logout-settings/logout-settings';
import LoginSettings from './login-settings/login-settings';
import PasswordChange from './password-change/password-change';
import Messages from './messages/messages';
import ExchangeOrders from './exchange-orders/exchange-orders/exchange-orders';
import ExchangeOrderDetails from './exchange-orders/exchange-order-details';
import NewExchangeOrder from './exchange-orders/new-exchange-order/new-exchange-order';
import UnitOrders from './unit-orders/unit-orders/unit-orders';
import UnitOrderDetails from './unit-orders/unit-order-details';
import MoneyTransitions from './money-transition/money-transitions/money-transitions';
import MoneyTransitionDetails from './money-transition/money-transition-details';
import SecurityTransitions from './security-transition/security-transitions/security-transitions';
import SecurityTransitionDetails from './security-transition/security-transition-details';
import CurrencyConversions from './currency-conversion/currency-conversions/currency-conversions';
import CurrencyConversionDetails from './currency-conversion/currency-conversion-details';
import SecurityTransfers from './security-transfer/security-transfers/security-transfers';
import SecurityTransferDetails from './security-transfer/security-transfer-details';
import MoneyTransfers from './money-transfer/money-transfers/money-transfers';
import MoneyTransferDetails from './money-transfer/money-transfer-details';
import LocaleSettings from "./locale-settings/locale-settings";

export const Screens = {
  MainScreen,
  Dashboard,
  Login,
  Profile,
  PersonalData,
  Settings,
  LoadingScreen,
  Contact,
  Notifications,
  LoginSettings,
  LogoutSettings,
  LocaleSettings,
  PasswordChange,
  Messages,
  ExchangeOrders,
  ExchangeOrderDetails,
  NewExchangeOrder,
  UnitOrders,
  UnitOrderDetails,
  MoneyTransitions,
  MoneyTransitionDetails,
  SecurityTransitions,
  SecurityTransitionDetails,
  CurrencyConversions,
  CurrencyConversionDetails,
  SecurityTransfers,
  SecurityTransferDetails,
  MoneyTransfers,
  MoneyTransferDetails,
};
